module.exports = __webpack_public_path__ + "img/host4.c94588bc.png";